import angular from 'angular';
import EventService from './event.service.js';
import EventSchema from './event.schema';

let eventModule = angular.module('event', [])

    .service('EventService', EventService)
    .constant('EventSchema', EventSchema)
    .name;

export default eventModule;
